import FaxIcon from '@mui/icons-material/Fax';
import HomeIcon from '@mui/icons-material/Home';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import WorkIcon from '@mui/icons-material/Work';

import { COLORS } from '~/styles/colors';

type PhoneType = 'CELL' | 'MOBILE' | 'WORK' | 'HOME' | 'FAX' | 'OTHER';

export const getIconPhoneByType = (type: PhoneType, size: number = 20) => {
  const iconProps = { sx: { color: COLORS.black06, width: `${size}px`, height: `${size}px` } };

  switch (type) {
    case 'CELL':
    case 'MOBILE':
      return <PhoneIphoneIcon {...iconProps} />;
    case 'WORK':
      return <WorkIcon {...iconProps} />;
    case 'HOME':
      return <HomeIcon {...iconProps} />;
    case 'FAX':
      return <FaxIcon {...iconProps} />;
    case 'OTHER':
    default:
      return <LocalPhoneIcon {...iconProps} />;
  }
};
